/**
 * T093: Tags Service
 * API methods for tag operations
 */

import { apiGet, apiPost, apiPatch, apiDelete } from './api'
import type { TagResponse, TagListResponse } from '@arcanum/core'

export type { TagResponse, TagListResponse }

export interface TagFilters {
  page?: number
  limit?: number
}

export interface CreateTagInput {
  name: string
}

export interface UpdateTagInput {
  name?: string
}

/**
 * List all tags
 */
export async function listTags(params?: TagFilters): Promise<TagListResponse> {
  return apiGet<TagListResponse>('/api/v1/tags', params as Record<string, string | number | boolean | undefined>)
}

/**
 * Get a single tag by ID
 */
export async function getTag(id: string): Promise<TagResponse> {
  return apiGet<TagResponse>(`/api/v1/tags/${id}`)
}

/**
 * Create a new tag
 */
export async function createTag(input: CreateTagInput): Promise<TagResponse> {
  return apiPost<TagResponse>('/api/v1/tags', input)
}

/**
 * Update an existing tag
 */
export async function updateTag(id: string, input: UpdateTagInput): Promise<TagResponse> {
  return apiPatch<TagResponse>(`/api/v1/tags/${id}`, input)
}

/**
 * Delete a tag
 */
export async function deleteTag(id: string): Promise<void> {
  return apiDelete(`/api/v1/tags/${id}`)
}
